import Base from './base'

export default class MelodyEmails extends Base {
  create(payload) {
    return this.api.post('emails/new.json', payload)
  }
}
